export default __webpack_public_path__ + "static/media/13Artboard-1-copy-100.d0ee811d.png";